// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// NEW: Import the getStorage function
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
const firebaseConfig = {
  apiKey: "AIzaSyD8PwFU1SXo67-u0cseo4d4FztNWnPrueI",
  authDomain: "fanfic-platform-app.firebaseapp.com",
  projectId: "fanfic-platform-app",
  storageBucket: "fanfic-platform-app.firebasestorage.app",
  messagingSenderId: "130303627337",
  appId: "1:130303627337:web:37cb376858223bd66f2f98",
  measurementId: "G-9TJVXC59H7"
};
// Your web app's Firebase configuration
// PASTE YOUR COPIED CONFIG OBJECT HERE
const firebaseApp = initializeApp(firebaseConfig);
const functions = getFunctions(firebaseApp); // ++ AÑADE ESTA LÍNEA ++





// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export {functions };
